import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import { N0 } from '@atlaskit/theme/colors';
import { SPOTLIGHT_ID, SPOTLIGHT_TARGET_ID } from './constants';
import { messages } from './messages';
export const MeatballSpotlight = ({
  onAcknowledge
}) => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(SpotlightTransition, null, /*#__PURE__*/React.createElement(Spotlight, {
    target: SPOTLIGHT_TARGET_ID,
    heading: intl.formatMessage(messages.title),
    actions: [{
      text: /*#__PURE__*/React.createElement(FormattedMessage, messages.ok),
      onClick: onAcknowledge
    }],
    dialogPlacement: "left middle",
    dialogWidth: 336,
    key: SPOTLIGHT_ID,
    targetBgColor: `var(--ds-surface-raised, ${N0})`
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, /*#__PURE__*/React.createElement(FormattedMessage, fg('itsm-issue-renaming') ? messages.messageIssueTermRefresh : messages.message))));
};